import { h } from 'preact'
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../../modal'
import ButtonControl from '../../button-control'
import DropdownControl from '../../dropdown/DropdownControl'
import InputGroup from '../../ui-components/InputGroup'

type ParentCategory = {
  id: number,
  title: string
}

interface Props {
  changeParentCategoryError?: string,
  isLoading: boolean,
  onSelectParentCategory: (parentCategory: string) => void,
  onSubmit: () => void,
  onClose: () => void,
  parentCategories: ParentCategory[],
  selectedParentCategory?: string,
  showModal: boolean
}

const ChangeParentCategoryModal = (props: Props) => {
  const {
    changeParentCategoryError,
    isLoading,
    onSelectParentCategory,
    onSubmit,
    onClose,
    parentCategories,
    selectedParentCategory,
    showModal
  } = props

  return (
    <Modal isOpen={showModal} size='medium'>
      <ModalHeader title='Change parent category' onClose={onClose} />
      <ModalBody>
        <div class='change-parent-category-modal'>
          <div>Select the parent category where you want to move this category to. Users with activity in this category won't be notified about the change.</div>
          <InputGroup title={'Move to'} error={changeParentCategoryError} customInput={
            <DropdownControl
              align='adjust'
              triggerClass={'parent-category-dropdown'}
              items={
                parentCategories.map((parentCategory: ParentCategory) => ({
                  title: parentCategory.title,
                  onClick: () => onSelectParentCategory(parentCategory.title)
                }))}
              trigger={
                <ButtonControl
                  class={selectedParentCategory ? 'selected' : 'default'}
                  title={selectedParentCategory || 'Select a parent category'}
                  icon={'arrowDropdown'}
                />
              } />
          } />
        </div>
      </ModalBody>
      <ModalFooter>
        <ButtonControl
          title='Save changes'
          variant='success'
          onClick={onSubmit}
          class='qa-save-change-parent-category'
          isLoading={isLoading}
        />
        <ButtonControl
          title='Cancel'
          onClick={onClose}
        />
      </ModalFooter>
    </Modal>
  )
}

export default ChangeParentCategoryModal
